module.exports = "pegasus/assets/blocks/image-1-basic.png";